import { useState } from 'react';
import { questions } from './api-data';

export default function FlashCards() {
  const [clickedId, setClickedId] = useState(null);

  function handleClick(id) {
    setClickedId(id !== clickedId ? id : null);
  }

  return (
    <div>
      <h2>Flash Cards</h2>
      <div className='flashcards'>
        {questions.map((q) => (
          <div
            className={`${clickedId === q.id ? 'selected' : ''}`}
            onClick={() => handleClick(q.id)}
            key={q.id}
          >
            {`${clickedId === q.id ? q.answer : q.question} `}
          </div>
        ))}
      </div>
    </div>
  );
}
